import { fetchAuthSession } from 'aws-amplify/auth';
import API_BASE from './apiBase';

export const ADMIN_GROUP = 'admin';


/** Returns the current Cognito ID token (JWT string) or null when signed out. */
export const getIdToken = async () => {
  try {
    const session = await fetchAuthSession();
    return session?.tokens?.idToken?.toString() || null;
  } catch (e) {
    return null;
  }
};

/** Authorization header for API calls; empty object when there is no session. */
export const authHeaders = async () => {
  const token = await getIdToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Who the current login is, straight from the ID token claims (username, groups).
 * Customer access is looked up server-side from the access table.
 */
export const getCurrentUserInfo = async () => {
  try {
    const session = await fetchAuthSession();
    const payload = session?.tokens?.idToken?.payload;
    if (!payload) return null;
    const groups = Array.isArray(payload['cognito:groups']) ? payload['cognito:groups'] : [];
    return {
      username: payload['cognito:username'] || payload.username || payload.sub,
      email: payload.email,
      groups,
      isAdmin: groups.includes(ADMIN_GROUP),
    };
  } catch (e) {
    return null;
  }
};

/**
 * The caller's full profile from the API: token identity plus account, role and
 * customer number from the assignment store. Null when signed out or unreachable.
 */
export const fetchMe = async () => {
  try {
    const headers = await authHeaders();
    if (!headers.Authorization) return null;
    const response = await fetch(`${API_BASE}/me`, { headers });
    if (!response.ok) return null;
    return (await response.json()).user;
  } catch (e) {
    return null;
  }
};

/**
 * Tells the API the user is active; the API records "last seen" for the Users page.
 * Fire-and-forget — never blocks the app.
 */
export const touchSession = async () => {
  try {
    const headers = await authHeaders();
    if (!headers.Authorization) return;
    await fetch(`${API_BASE}/me`, { headers });
  } catch (e) {
    /* offline or API unavailable; not important */
  }
};
